import usePrivateAxios from '@/common/api/usePrivateAxios'
import { defaultTransformerResponse } from '@/common/constants/defaultTransformerResponse.constant'
import { Mapper } from '@/common/services/mapper'
import { MetaResponse } from '@/common/types/metaResponse'
import { keepPreviousData, useQuery } from '@tanstack/react-query'

type UseRewardLedgerEntriesProps<T> = {
  userId: string
  filters?: {
    page?: number
    fromType?: string
  }
  mapper?: (data: any) => T
}

export const useRewardLedgerEntries = <T,>({
  userId,
  filters: { page, fromType } = {},
  mapper = Mapper.default<T>(),
}: UseRewardLedgerEntriesProps<T>) => {
  const privateAxios = usePrivateAxios()

  const {
    data: { data, meta } = defaultTransformerResponse<T>(),
    isPending,
    ...rest
  } = useQuery({
    queryKey: ['rewardLedgerEntries', userId, page, fromType],
    queryFn: () => {
      return privateAxios.get('/tmais/reward_ledger_entries', {
        params: {
          page,
          'q[user_id_eq]': userId,
          'q[from_type_eq]': fromType,
        },
      })
    },
    select: (data: { data: { data: any[]; meta: MetaResponse } }) => {
      return {
        data: mapper(data?.data?.data),
        meta: data?.data?.meta,
      }
    },
    placeholderData: keepPreviousData,
    enabled: !!userId,
  })

  return { data, meta, isPending, ...rest }
}
